module.exports = __webpack_public_path__ + "img/logo.d4a275f5.jpg";